import axios from 'axios';

// Auto-detect base path for demos
const getApiUrl = () => {
  if (typeof window !== 'undefined') {
    const path = window.location.pathname;
    const demoMatch = path.match(/^\/demo\/([^/]+)/);
    if (demoMatch) {
      return `/demo/${demoMatch[1]}/api`;
    }
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
};

const API_URL = getApiUrl();

console.log('API URL:', API_URL);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const register = async (userData) => {
  const response = await api.post('/users/register', userData);
  return response.data;
};

export const login = async (credentials) => {
  console.log('Intentando login con:', credentials);
  console.log('Intentando login con URL:', `${API_URL}/users/login`);
  try {
    const response = await api.post('/users/login', credentials);
    console.log('Login response:', response);
    return response;
  } catch (error) {
    console.error('Login error completo:', error);
    throw error;
  }
};
export const getUserProfile = () => api.get('/users/profile');
export const getCourses = () => api.get('/courses');

export const getUserCourses = async (userId) => {
  try {
    const response = await api.get(`/users/${userId}/courses`);
    const data = response.data;
    const processedData = data.map(course => {
      if (course.test && course.test.questions) {
        course.test.questions = course.test.questions.map(q => ({
          ...q,
          correctAnswer: q.correct_answer
        }));
      }
      if (course.deadline) {
        course.deadline = new Date(course.deadline);
      }
      return course;
    });
    console.log("Processed user courses data:", processedData);
    return processedData;
  } catch (error) {
    console.error('Error fetching user courses:', error);
    throw error;
  }
};

export const getCourse = async (id) => {
  try {
    const response = await api.get(`/courses/${id}`);
    const data = response.data;
    if (data.test && data.test.questions) {
      data.test.questions = data.test.questions.map(q => ({
        ...q,
        correctAnswer: q.correct_answer
      }));
    }
    return data;
  } catch (error) {
    console.error('Error fetching course:', error);
    throw error;
  }
};

export const getAllCoursesWithProgress = async () => {
  try {
    const response = await api.get('/courses/all-with-progress');
    return response.data;
  } catch (error) {
    console.error('Error fetching courses with progress:', error);
    throw error;
  }
};

export const getAllUsersWithProgress = async () => {
  try {
    const response = await api.get('/users/all-with-progress');
    return response.data;
  } catch (error) {
    console.error('Error fetching users with progress:', error);
    throw error;
  }
};

export const getAllCourses = async () => {
  try {
    const response = await api.get('/courses/stats');
    return response.data;
  } catch (error) {
    console.error('Error fetching all courses:', error);
    throw error;
  }
};

export const createCourse = (courseData) => {
  return api.post('/courses', courseData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const getProgress = (courseId) => api.get(`/progress/${courseId}`);

export const updateProgress = (userId, courseId, progressData) => {
  console.log('Updating progress:', { userId, courseId, progressData });
  return api.patch(`/progress/${userId}/${courseId}`, progressData);
};

export const getUsers = () => api.get('/admin/users');
export const updateUserRole = (userId, role) => api.patch(`/admin/users/${userId}/role`, { role });
export const deleteUser = (userId) => api.delete(`/admin/users/${userId}`);
export const getAdminCourses = () => api.get('/admin/courses');
export const getUserCourseHistory = (userId) => api.get(`/users/${userId}/course-history`);

export const updateCourse = async (id, formData) => {
  try {
    const response = await api.put(`/courses/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response;
  } catch (error) {
    console.error('Error en updateCourse:', error);
    throw error;
  }
};

export const generateCourse = (formData) => {
  return api.post('/auto-course-generator', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const saveCourse = (courseData) => {
  return api.post('/courses', courseData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const deleteCourse = (courseId) => {
  return api.delete(`/courses/${courseId}`);
};

export const updateCourseFiles = (id, formData) => {
  return api.post(`/courses/${id}/update-files`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const getUserCertificates = (userId) => {
  return api.get(`/certificates/user/${userId}/data`);
};

export const enrollUserToCourse = async (enrollmentData) => {
  try {
    const response = await api.post('/enrollments', enrollmentData);
    return response.data;
  } catch (error) {
    console.error('Error enrolling user(s) to course:', error);
    throw error;
  }
};

export const getAllDepartments = async () => {
  try {
    const response = await api.get('/users/departments');
    return response.data;
  } catch (error) {
    console.error('Error fetching departments:', error);
    throw error;
  }
};

export const getAllDeadlines = async () => {
  try {
    const response = await api.get('/users/deadlines');
    return response.data;
  } catch (error) {
    console.error('Error fetching all deadlines:', error);
    throw error;
  }
};

export const getAllCertificates = async () => {
  try {
    const response = await api.get('/certificates');
    return response.data;
  } catch (error) {
    console.error('Error fetching all certificates:', error);
    throw error;
  }
};

export const downloadCertificatesByCourse = async (courseId) => {
  try {
    const response = await api.get(`/certificates/course/${courseId}`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `certificates_course_${courseId}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error('Error downloading certificates by course:', error);
    throw error;
  }
};

export const downloadCertificatesByUser = async (userId) => {
  try {
    const response = await api.get(`/certificates/user/${userId}`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `certificates_user_${userId}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error('Error downloading certificates by user:', error);
    throw error;
  }
};

export const updateUser = (userId, userData) => {
  return api.put(`/admin/users/${userId}`, userData);
};

export const createUser = (userData) => {
  return api.post('/admin/users', userData);
};

export const getUserTestHistory = async (userId) => {
  try {
    const response = await api.get(`/users/${userId}/test-history`);
    return { ...response.data, attempts: response.data.attempts || [] };
  } catch (error) {
    console.error('Error fetching user test history:', error);
    return { attempts: [], totalAttempts: 0, passedAttempts: 0, averageScore: 0 };
  }
};

export const getCourseHistory = async (courseId) => {
  try {
    const response = await api.get(`/courses/${courseId}/history`);
    return response.data;
  } catch (error) {
    console.error('Error fetching course history:', error);
    throw error;
  }
};

export const getAllCourseHistory = async () => {
  try {
    const response = await api.get('/courses/history/all');
    return response.data;
  } catch (error) {
    console.error('Error fetching course history:', error);
    throw error;
  }
};

export const exportHistoryToPDF = async () => {
  try {
    const response = await api.get('/courses/history/export/pdf', { responseType: 'blob' });
    return response.data;
  } catch (error) {
    console.error('Error exporting history to PDF:', error);
    throw error;
  }
};

export const exportHistoryToExcel = async () => {
  try {
    const response = await api.get('/courses/history/export/excel', { responseType: 'blob' });
    return response.data;
  } catch (error) {
    console.error('Error exporting history to Excel:', error);
    throw error;
  }
};

export const updateGMPHistory = async (id, formData) => {
  try {
    const response = await api.put(`/courses/${id}/gmp-update`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response;
  } catch (error) {
    console.error('Error en updateGMPHistory:', error);
    throw error;
  }
};

export const getGMPHistory = async (courseId) => {
  try {
    const url = courseId ? `/courses/history/gmp?courseId=${courseId}` : '/courses/history/gmp';
    const response = await api.get(url);
    console.log("GMP history response:", response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching GMP history:', error);
    throw error;
  }
};

export const exportGMPHistory = async (format) => {
  try {
    const response = await api.get(`/courses/history/gmp/export/${format}`, { responseType: 'blob' });
    return response.data;
  } catch (error) {
    console.error('Error exporting GMP history:', error);
    throw error;
  }
};

export const updateGMPCourse = async (id, formData) => {
  try {
    const response = await api.put(`/courses/${id}/gmp`, formData);
    return response;
  } catch (error) {
    console.error('Error en updateGMPCourse:', error);
    throw error;
  }
};

export default api;
